import { useSelector } from "@shared/hooks/shared/useTypedSelector";

export const useIsSweepstakesEnabled = () => {
  return useSelector(({ lobby }: TRootState) => lobby.params?.sweepstakes);
};

export const useIsSweepstakesExchangeEnabled = () => {
  return useSelector(
    ({ lobby }: TRootState) =>
      lobby.params?.lobbyButtons?.ssUpdateBalance?.enabled ?? false
  );
};
